<template>
  <div>
    <div v-if="$model.isAdmin" class="my-3">
      <v-btn @click="newCategory()" color="primary">Добавить тип документа</v-btn>
    </div>
    <!--v-if чтобы исключить из DOM при закрытии, потом re-render-->
    <v-dialog width="900" v-model="showDialog" v-if="showDialog" persistent scrollable>
      <v-card height="600">
        <v-toolbar color="blue-lighten-1">
          <v-toolbar-title v-if="categoryid === 0">
            Добавить новый тип документа
          </v-toolbar-title>
          <v-toolbar-title v-else>
            Редактировать приказ
          </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-0">
          <v-tabs v-model="tab" style="height: auto;">
            <v-tab v-for="i in tabs" :key="i.value" :disabled="i.disabled" :value="i.value">{{ i.title }}</v-tab>

            <v-tabs-window v-model="tab">
              <v-tabs-window-item v-for="i in tabs" :key="i.value" :value="i.value">
                <v-card flat tile>
                  <v-card-text class="">
                    <keep-alive>
                      <component :is="i.component" :categoryid="categoryid"
                        @change-categoryid="e => updateCategoryid(e)" v-model:saved="i.saved" />
                    </keep-alive>
                  </v-card-text>
                </v-card>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-tabs>
        </v-card-text>

        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>

          <v-btn color="primary" @click="save">Сохранить</v-btn>
          <v-btn color="primary" @click="hide">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/*
 * Каждая вкладка настроек сохраняется независимо
 * по событию save-category
 */
import baseTab from "./category-base-tab.vue";
import variablesTab from "./category-variables-tab.vue";
import customVariablesTab from "./category-customvariables-tab.vue";
import cycleTab from "./cycle-tab.vue";
import templateTab from "./category-template-tab.vue";
export default {
  emits: ["update:categoryid"],
  props: {
    categoryid: {
      required: true,
    },
  },
  data() {
    return {
      showDialog: false,
      tab: null,
      /*
      true при старте, чтобы так и не открытые вкладки
      понимались как сохраненные. Открытые вкладки поменяют
      состояние на false при создании и на true когда реально сохранят данные
      */
      tabs: [
        {
          title: "Общие настройки",
          value: "tab1",
          component: "baseTab",
          saved: true,
          disabled: false,
        },
        {
          title: "Стандартные переменные",
          value: "tab2",
          component: "variablesTab",
          saved: true,
          disabled: false,
        },
        {
          title: "Пользовательские переменные",
          value: "tab3",
          component: "customVariablesTab",
          saved: true,
          disabled: false,
        },
        {
          title: "Жизненный цикл",
          value: "tab4",
          component: "cycleTab",
          saved: true,
          disabled: false,
        },
        {
          title: "Шаблоны",
          value: "tab5",
          component: "templateTab",
          saved: true,
          disabled: false,
        },
      ],
      saved: false, //кнопка сохранить тыкнута?
    };
  },
  components: {
    variablesTab,
    baseTab,
    customVariablesTab,
    cycleTab,
    templateTab,
  },
  computed: {
    documentSaved() {
      //return this.tabs[0].saved&&this.tabs[1].saved&&....
      return Object.values(this.tabs).reduce(function (
        accumulator,
        currentValue
      ) {
        if (typeof accumulator == "boolean") {
          return accumulator && currentValue.saved;
        }
        return accumulator.saved && currentValue.saved;
      });
    },
  },
  watch: {
    documentSaved(newValue) {
      if (newValue && this.saved) {
        this.hide();
        this.$eventBus.$emit("categories-reload-documents", true);
      }
    },
    //categories.editcategory sync with this.categoryid
    //after event reload-documents this hide
    categoryid(newValue, oldValue) {
      if (newValue === false) {
        this.hide();
      } else {
        if (newValue == 0) {
          for (let k in this.tabs) {
            if (this.tabs[k].value != "tab1") {
              this.tabs[k].disabled = true;
            }
          }
        } else {
          for (let k in this.tabs) {
            this.tabs[k].disabled = false;
          }
        }
        this.$eventBus.$emit("categories-reload-documents", false);
        this.showDialog = true;
      }
    },
    /*saved(newValue) {
      if (newValue && this.documentSaved) {
        this.hide();
        this.$eventBus.$emit("categories-reload-documents");
      }
    },*/
  },
  methods: {
    updateCategoryid(id) {
      this.$emit("update:categoryid", id);
    },
    newCategory() {
      this.saved = false;
      this.$emit("update:categoryid", 0);
    },
    hide() {
      this.showDialog = false;
      this.saved = false;
      this.$emit("update:categoryid", false);
    },
    save() {
      this.saved = true;
      /*
            каждая вкладка сохраняется сама по себе, важно чтобы
            категория (categoryid) уже была создана, поэтому если
            создаем новую категорию, сначала создание/получение id
            потом событие save-category по всем вкладкам
      */
      this.$eventBus.$emit("save-category");
    },
  },
};
</script>
<style lang="scss">
/**
табы мултилайн+перенос строк
 */
div.v-dialog {
  .v-slide-group__content {
    flex-wrap: wrap;
    flex: 1 1 auto !important;
  }

  button.v-tab.v-btn {
    display: flex;
    flex: 1 1 0;

    span.v-btn__content {
      white-space: normal;
      text-align: left;
    }
  }

  div.v-window.v-tabs-window {
    flex-basis: 100%;
  }
}
</style>
